export const ACTION_TYPES = {
  GET_DOCUMENTS: 'document/GET_DOCUMENTS',
  UPLOAD_DOCUMENTS: 'document/UPLOAD_DOCUMENTS',
  GET_PAPERANDDOC: 'document/GET_PAPER_AND_DOC',
};
